import { event } from 'vue-gtag';
import {usePage} from "@inertiajs/vue3";

const isProduction = () => {
    return usePage().props.environment === 'production';
}

const runIfProduction = (fn) => {
    return async function (...args) {
        if (isProduction()) {
            return await fn(...args);
        } else {
            console.log('Not in production — skipping execution.');
            return;
        }
    };
};

export const exerciseGenerated = runIfProduction(async (exercise) => {
    event('exercise_generated', {
        exercise_id: exercise.id,
        exercise_title: exercise.translations?.[0]?.title ?? "не задано",
        value: 0.2,
        currency: 'EUR',
        course_id: exercise.course.id,
        language_level: exercise.course.language_level_id
    });
});

export const exerciseEvaluated = runIfProduction((assessment, exercise, award) => {
    if (!assessment) {
        return;
    }

    const stats = {correct: 0, incorrect: 0, totalScore: 0};

    if (assessment.evaluation) {
        const stats = assessment.evaluation.reduce((acc, part) => {
            acc.correct += part.words_mastered.length;
            acc.incorrect += part.words_to_review.length;
            acc.totalScore += part.score;
            return acc;
        }, {correct: 0, incorrect: 0, totalScore: 0});
    }

    const maxPossibleScore = exercise.max_points ?? 10;

    event('exercise_evaluated', {
        exercise_id: exercise.id,
        exercise_points: assessment.evaluation.reduce((sum, part) => sum + part.score, 0) ?? 0,
        value: 0.02,
        currency: 'EUR',
        course_id: exercise.course.id,
        language_level: exercise.course.language_level_id,
        correct_answers_count: stats.correct,
        incorrect_answers_count: stats.incorrect,
        score_percent: maxPossibleScore > 0 ? Math.round((stats.totalScore / maxPossibleScore) * 100) : 0
    })
})

export const wordAdded = runIfProduction((data) => {
    event('word_added', {
        word: data.expression,
        value: 0.01,
        currency: 'EUR',
        source: 'module',
        module_id: data.id,
        module_title: data.title
    });
})

export const userLoggedIn = runIfProduction((user) => {
    event('user_logged_in', {
        user_id: user.id
    })
});

export const userRegistered = runIfProduction((user, referrerUser) => {
    const data = {
        user_id: user.id,
        utm_content: ''
    };
    if (referrerUser) {
        data.referrer_user_id = referrerUser.id;
    }
    if (document.referrer) {
        data.previous_page_url = document.referrer
    }

    event('user_registered', data);
})

export const userForgetPassword = runIfProduction((email) => {
    event('user_forget_password', { email });
})

export const userConfirmedEmail = runIfProduction((user) => {
    event('user_email_confirmed', {
        user_id: user.id
    });
})


export const userClosedOnboarding = runIfProduction((user, id) => {
    event('user_closed_onboarding', {
        user_id: user.id,
        id: id
    });
})

export const userClickedOnboarding = runIfProduction((user, id) => {
    event('user_clicked_onboarding', {
        user_id: user.id,
        id: id
    });
})
